import { render, staticRenderFns } from "./appendinfo.vue?vue&type=template&id=91cf15ea&scoped=true&"
import script from "./appendinfo.vue?vue&type=script&lang=js&"
export * from "./appendinfo.vue?vue&type=script&lang=js&"
import style0 from "./appendinfo.vue?vue&type=style&index=0&id=91cf15ea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cf15ea",
  null
  
)

export default component.exports